import { render } from "./BiDashboardApp.vue?vue&type=template&id=3791149b&scoped=true"
import script from "./BiDashboardApp.vue?vue&type=script&lang=js"
export * from "./BiDashboardApp.vue?vue&type=script&lang=js"

import "./BiDashboardApp.vue?vue&type=style&index=0&id=3791149b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3791149b"]])

export default __exports__